export default {
    nl: {
        intro: {
            subtitle: 'Back-end development',
            title: 'Alles laten werken.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/back-end-development/hero.jpg',
        },
        type: 'Back-end development',
        title: 'Back-end development: de kracht achter digitale producten',
        description:
            'Ons ervaren back-end development team biedt schaalbaarheid, snelheid en maatwerk voor jouw digitale producten en uitdagingen.',
        content: [
            {
                type: 'text',
                title: 'Back-end development',
                content:
                    'Je ziet het niet direct, maar het is altijd aanwezig en absoluut onmisbaar: back-end development. Dit vormt de solide basis van elk digitaal product en draait om het uitdenken, implementeren en onderhouden van alles wat achter de schermen gebeurt.',
            },
            {
                type: 'images',
                images: [
                    'https://23g-website.s3.eu-central-1.amazonaws.com/services/development.webp',
                ],
                imageWidth: 817,
            },
            {
                type: 'text',
                title: 'Onze expertise in back-end development',
                content: `
                    Onze back-end developers zijn experts in hun vakgebied en beschikken over de nodige vaardigheden en tools. We zijn bedreven in programmeren met PHP als de voorkeurstaal, waardoor we krachtige webapplicaties ontwikkelen. Daarbij maken we gebruik van frameworks zoals Laravel voor complexe maatwerk applicaties en WordPress voor snelle, kant-en-klare oplossingen.
                    <br><br>
                    Met een sterke focus op DevOps leggen onze developers de nadruk op schaalbaarheid, snelheid en stabiliteit van je digitale product. Door geautomatiseerde processen te gebruiken, zoals die beschikbaar zijn op AWS (Amazon Web Services), zorgen we voor een snelle en efficiënte ontwikkeling en implementatie. AWS biedt een betrouwbare en flexibele infrastructuur die meegroeit met de behoeften van jouw onderneming, zodat je effectief kunt inspelen op marktveranderingen.
                `,
            },
            {
                type: 'text',
                title: 'Maatwerk en flexibiliteit',
                content:
                    'Wij creëren technisch gedreven, schaalbare software voor een snel veranderende wereld. Of je nu op zoek bent naar een maatwerkoplossing of een kant-en-klaar product, wij helpen je. Onze ontwikkelings teams beschikken over een breed scala aan expertise en kunnen elke zakelijke uitdaging aan. Iedere dag zijn onze experts betrokken bij het ontwikkelen van oplossingen die bedrijfsprocessen naar een hoger niveau tillen. Bovendien zijn al onze developers gecertificeerd in zowel AWS als Laravel, wat een extra garantie biedt voor kwaliteit en deskundigheid.',
            },
            {
                type: 'case',
                case: 'nines',
            },
        ],
        related_services: ['design-sprint', 'strategy-session', 'client-portal'],
        contact: {
            title: '',
            employee: 'tobias',
        },
    },
    en: {},
};
